




























































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Number from "@/shared/filters/Number";
import Pagination from "@/views/components/Pagination.vue";
import InputNumber from "@/views/components/input/InputNumber.vue";
import { CommonService } from "@/services/Common.service";
import { Seibi } from "@/models/Seibi";
import InputString from "@/views/components/input/InputString.vue";
import { SeibiService } from "@/services/Seibi.service";
import { BuhinsService } from "@/services/Buhins.service";
import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import { ShatenService } from "@/services/shaten.service";
import { Utils } from "@/services/utils";
import DialogExtremeImport from "./components/DialogExtremeImport.vue";
import DialogFreeOfCharge from "./components/DialogFreeOfCharge.vue";

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination
    , DialogExtremeImport
    , DialogFreeOfCharge
  },
  mixins: [FilterSelectBox]
})
export default class SeibiDetail extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  commonService = new CommonService();
  public seibiService = new SeibiService();
  public buhinService = new BuhinsService();
  shatenService: ShatenService = new ShatenService();
  loading: boolean = false;
  seibiList: Seibi[] = [];
  seibiFilterList: Seibi[] = [];
  seibiPageList: Seibi[] = [];
  jidoushaShubetsuList: any = [];

  seibiEditData: Seibi = {
    sknInspectSeibiDetailId: null,
    sknInspectSeibiTitle: "",
    koukanMeyasuTime: 0,
    seibiKousuuItem: [],
    workGroupNm: "",
    shuukeiKbnNm: "",
    genka: 0
    // 2022-01-31 morisako kobac-free add [START]
    , isFree: null
    , isDiscount: null
    // 2022-01-31 morisako kobac-free add [END]
  };
  sknInspectSeibiTitle = "";
  disableBtnEdit: boolean = true;
  showConfirmDelete: boolean = false;
  showConfirmExpDelete: boolean = false;
  showWorkBuhinDialog: boolean = false;

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;

  idEdit = -1;
  versionList: any = [];
  feeList: any = [];
  hasExtensionId = false;
  utils = new Utils();
  isNotAdmin = true;
  idDelete: any = null;
  currentTypeIndex: number = 0;
  shuukeiDataList: any = [];
  workGroupDataList: any = [];
  expSeibiList: Seibi[] = [];
  searchVO: any = {
    page: 1
    , size: this.itemSizeSelected
  };
  maxCnt: number = 0;
  expSeibiEditData: any = {};
  expDelete: any = null;
  expBuhinList: any = [];
  osusumeInspectSeibiList: any = [];
  importPtns: any = [];
  // 2022-01-31 morisako kobac-free add [START]
  dialogFreeOfChargeBtnFlg: boolean = true;
  dialogFreeOfChargeNm: boolean = false;
  freeOfChargeNm: string = '';
  groupCd: any = '';
  shatenCd: any = '';
  shatenNm: any = '';
  kyotenCd: any = '';
  kyotenNm: any = '';
  version: any = '';
  sknInspectSeibiFeeId: any = '';
  sknInspectSeibiFeeNm: any = '';
  // 2022-01-31 morisako kobac-free add [END]

  $refs!: {
    dialogExtremeImport: DialogExtremeImport;
    dialogFreeOfCharge: DialogFreeOfCharge;
  };

  private mounted() {
    this.form = {
      kyotenCd: "",
      groupCd: "",
      shatenCd: "",
      version: "",
      sknInspectSeibiFeeId: ""
      , isFree: false
    };
    const loginTypeKbn = localStorage.getItem("loginTypeKbn");
    if (loginTypeKbn === "1" || loginTypeKbn === "10") {
      this.isNotAdmin = false;
    }

    this.getKbnSkns("jidoushaShubetsuList", "skn_jidousha_shubetsu", "7101");
    this.getGroupDataList().then(res => {
      this.getShatens().then(res2 => {
        if (res2 && res2.length > 0) {
          /** 2022-04-20 sh #7831 fix if length of res2 is not one, not set to form. [START] */
          // this.$set(this.form, "shatenCd", res2[0].shatenCd);
          this.$set(this, "shatenDataList", res2);
          if (res2.length === 1) {
            this.$set(this.form, "shatenCd", res2[0].shatenCd);
          }
          /** 2022-04-20 sh #7831 fix if length of res2 is not one, not set to form. [END] */
          this.getKyotenDataList().then(res3 => {
            if (res3) {
              if (res3.length == 0) {
                this.form.kyotenCd = "";
              } else {
                this.form.kyotenCd = localStorage.getItem("kyotenCd");
              }
              this.getVersionList().then(() => {
                if (this.versionList.length === 1) {
                  this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
                }
                this.getFeeList().then(() => {
                  this.getSeibiList();
                });
              });
            }
          });
        }
      });
    });
    this.getMExpSeibiShuukeiKbn();
    this.getMExpSeibiWorkGroup();
    this.getKbnSkns("importPtns", "import_ptn", "43");
  }

  async getFeeList() {
    this.feeList = await this.shatenService.getInspectMenuFee(
      this.form.version
    );

    const feeId = this.utils.getFeeIdBase(this.feeList);
    if (feeId) {
      this.$set(this.form, "sknInspectSeibiFeeId", feeId);
    }
    // this.getSeibiList();
  }

  selectFee() {
    if (this.form.sknInspectSeibiFeeId) {
      // 2022-01-31 morisako kobac-free add [START]
      if (this.currentTypeIndex == 0) {
      // 2022-01-31 morisako kobac-free add [END]
      this.getSeibiList();
      // 2022-01-31 morisako kobac-free add [START]
      } else if (this.currentTypeIndex == 1) {
        this.getExpSeibiList();
      } else if (this.currentTypeIndex == 2) {
        this.getOsusumeInspectSeibi();
      }
      // 2022-01-31 morisako kobac-free add [END]
    }
  }

  async getKyotenDataList() {
    this.form.version = "";
    this.form.sknInspectSeibiFeeId = "";
    this.versionList = [];
    const response = await this.commonService.getKyotenHasVersion(
      this.form.groupCd,
      this.form.shatenCd
    );
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
    // if (this.kyotenDataList.length === 0) {
    //   this.form.kyotenCd = "";
    //   this.getVersionList();
    // }
    return response;
  }

  async selectGroup1() {
    this.form.shatenCd = null;
    this.form.kyotenCd = "";
    this.kyotenDataList = [];
    this.form.version = "";
    this.versionList = [];
    // this.selectGroup();
    // 2022-01-31 morisako kobac-free add [START]
    this.shatenDataList = [];
    // 2022-01-31 morisako kobac-free add [END]
    this.getShatens().then(res2 => {
      if (res2 && res2.length > 0) {
        this.$set(this.form, "shatenCd", res2[0].shatenCd);
        this.getKyotenDataList().then(res3 => {
          if (res3) {
            if (res3.length == 0) {
              this.form.kyotenCd = "";
            } else {
              this.form.kyotenCd = localStorage.getItem("kyotenCd");
            }
            this.getVersionList().then(() => {
              if (this.versionList.length === 1) {
                this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
              }
              this.getFeeList();
            });
          }
        });
      }
    });
  }

  async getVersionList() {
    this.form.version = "";
    this.form.sknInspectSeibiFeeId = "";
    const res = await this.commonService.getHanyouSeibiVersion(
      this.form.groupCd,
      this.form.shatenCd,
      this.form.kyotenCd
    );
    this.$set(this, "versionList", res);
    // if (this.versionList.length === 1) {
    //   this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
    //   this.getFeeList();
    // } else if (this.versionList.length === 0) {
    //   this.getFeeList();
    // }
  }

  selectKyoten() {
    // this.getVersionList();
    this.getVersionList().then(() => {
      if (this.versionList.length === 1) {
        this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
      }
      this.getFeeList();
    });
  }

  selectVersion() {
    // this.getSeibiList();
    this.getFeeList();
  }

  public async getKbnSkns(nameKbn: string, sknTitle: string, kbnCd?: string) {
    const response = await this.commonService.getKbnSkns(sknTitle, kbnCd);
    if (response) {
      let data = response.filter((e: any) => e.isDisabled == 0);
      data = data.sort((a: any, b: any) => (a.num > b.num ? 1 : -1));
      this.$set(this, nameKbn, [...data]);
    } else {
      this.$set(this, nameKbn, []);
    }
  }

  checkDisabled() {
    let disabled = false;
    let btn = "disableBtnEdit";
    if (this.seibiEditData && this.seibiEditData.seibiKousuuItem) {
      this.seibiEditData.seibiKousuuItem.forEach(element => {
        if (element.kousuu === null || element.kousuu === undefined) {
          element.kousuu = 0;
        }
        if (!element.id) {
          disabled = true;
        }
      });
    }

    this.$set(this, btn, disabled);
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public updateSeibi() {
    if (this.seibiEditData.sknInspectSeibiDetailId) {
      this.loading = true;
      if (this.seibiEditData.koukanMeyasuTime === null) {
        this.seibiEditData.koukanMeyasuTime = 0;
      }
      this.addSeibiItem({
        ...this.seibiEditData,
        sknInspectSeibiFeeId: this.form.sknInspectSeibiFeeId
      });
    }
    this.idEdit = -1;
  }

  search() {
    // 2022-01-06 morisako add reset page [START]
    this.searchVO.page = 1;
    // 2022-01-06 morisako add reset page [END]
    if (this.currentTypeIndex == 0) {
      this.getSeibiList();
    } else if (this.currentTypeIndex == 1) {
      this.getExpSeibiList();
    } else if (this.currentTypeIndex == 2) {
      this.getOsusumeInspectSeibi();
    }
  }

  public async getSeibiList() {
    this.$set(this, "loading", true);
    const response = await this.seibiService.getSeibi(
      this.sknInspectSeibiTitle,
      this.form.version,
      this.form.sknInspectSeibiFeeId
      , this.form.isFree
    );
    this.$set(this, "loading", false);
    if (response) {
      const list = this.jidoushaShubetsuList.map((e: any) => e.kbnKey);
      const seibiList = response.map((item: any) => {
        item.seibiKousuuItem = item.seibiKousuuItem.sort(
          (a: any, b: any) =>
            list.indexOf(+a.jidoushaShubetsu) - list.indexOf(+b.jidoushaShubetsu)
        );
        return item;
      });
      this.$set(this, "seibiList", seibiList);
      this.filterExtensionId();
      // 2022-01-31 morisako kobac-free mod [START]
      if (this.form.isFree) {
        this.dialogFreeOfChargeBtnFlg = false;
      } else {
        this.dialogFreeOfChargeBtnFlg = true;
      }
      // 2022-01-31 morisako kobac-free mod [END]
    } else {
      this.maxCnt = 0;
      this.$set(this, "seibiList", []);
      this.$set(this, "seibiFilterList", []);
      this.$set(this, "seibiPageList", []);
      // 2022-01-31 morisako kobac-free mod [START]
      this.dialogFreeOfChargeBtnFlg = true;
      // 2022-01-31 morisako kobac-free mod [END]
    }
    this.checkDisabled();
  }

  public async addSeibiItem(data: any) {
    const response = await this.seibiService.editSeibi(data);
    if (response) {
      this.getSeibiList();
    } else {
      this.delay(1000);
    }
  }

  public onEdit(rowData: any) {
    this.idEdit = rowData.sknInspectSeibiDetailId;
    this.seibiEditData = JSON.parse(JSON.stringify(rowData));
  }

  getKousuu(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsu == kbn);
    if (index >= 0) {
      return list[index].kousuu;
    }
    return "-";
  }

  getKouchin(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsu == kbn);
    if (index >= 0) {
      return list[index].kouchinZn;
    }
    return "-";
  }

  getKouchinGenka(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsu == kbn);
    if (index >= 0) {
      return list[index].kouchinGenkaZn;
    }
    return "-";
  }

  getGroup(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsu == kbn);
    if (index >= 0) {
      return list[index].workGroupNm;
    }
    return "-";
  }

  getShuukeiKbn(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsu == kbn);
    if (index >= 0) {
      return list[index].shuukeiKbnNm;
    }
    return "-";
  }

  getGenka(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsu == kbn);
    if (index >= 0) {
      return list[index].genka;
    }
    return "-";
  }

  toggleStar() {
    this.hasExtensionId = !this.hasExtensionId;
    this.filterExtensionId();
  }

  filterExtensionId() {
    let seibiList: any = [];
    if (this.hasExtensionId) {
      seibiList = this.seibiList.filter((e: any) => {
        return (
          e.seibiKousuuItem.filter(
            (k: any) => k.sknInspectSeibiKousuuExtensionId
          ).length > 0
        );
      });
    } else {
      seibiList = this.seibiList;
    }
    this.$set(this, "seibiFilterList", this.utils.deepCopy(seibiList));
  }

  isHasExtensionId(item: any) {
    return (
      item.seibiKousuuItem.filter(
        (k: any) => k.sknInspectSeibiKousuuExtensionId
      ).length > 0
    );
  }

  onConfirmDelete(item: any) {
    this.showConfirmDelete = true;
    this.idDelete = item;
  }

  public async delSeibiItem() {
    if (this.idDelete) {
      this.loading = true;
      let id = this.idDelete.sknInspectSeibiDetailId;
      let feeId = this.idDelete.sknInspectSeibiFeeId;
      const response = await this.seibiService.deleteSeibi(id, feeId);
      if (response) {
        this.getSeibiList();
      } else {
        this.delay(1000);
      }
      this.idDelete = null;
    }
    this.showConfirmDelete = false;
  }

  async getMExpSeibiShuukeiKbn() {
    const res = await this.seibiService.getMExpSeibiShuukeiKbn();
    if (res) {
      this.shuukeiDataList = res;
    } else {
      this.shuukeiDataList = [];
    }
  }

  async getMExpSeibiWorkGroup() {
    const res = await this.seibiService.getMExpSeibiWorkGroup();
    if (res) {
      this.workGroupDataList = res;
    } else {
      this.workGroupDataList = [];
    }
  }

  public async getExpSeibiList() {
    this.$set(this, "loading", true);
    const response = await this.seibiService.getExpSeibi(this.searchVO, this.form, this.sknInspectSeibiTitle);
    this.$set(this, "loading", false);
    if (response) {
      if (response.length > 0) {
        this.maxCnt = response[0].maxCnt;
      }
      this.$set(this, "expSeibiList", response);
      // 2022-01-31 morisako kobac-free mod [START]
      if (this.form.isFree) {
        this.dialogFreeOfChargeBtnFlg = false;
      } else {
        this.dialogFreeOfChargeBtnFlg = true;
      }
      // 2022-01-31 morisako kobac-free mod [END]
    } else {
      this.maxCnt = 0;
      this.$set(this, "expSeibiList", []);
      // 2022-01-31 morisako kobac-free mod [START]
      this.dialogFreeOfChargeBtnFlg = true;
      // 2022-01-31 morisako kobac-free mod [END]
    }
    this.checkDisabled();
  }

  get getItemSizes() {
    return this.itemSizes.map((e: any) => e.value);
  }

  public handleCurrentChange(event: number) {
    this.searchVO.page = event;
    this.getExpSeibiList();
  }

  public handleSizeChange(event: number) {
    this.searchVO.page = 1;
    this.searchVO.size = event;
    this.getExpSeibiList();
  }

  isEdit(data: any) {
    if (this.expSeibiEditData.groupCd == data.groupCd
      && this.expSeibiEditData.shatenCd == data.shatenCd
      && this.expSeibiEditData.workCd == data.workCd) {
      return true;
    } else {
      return false;
    }
  }

  onExpEdit(data: any) {
    this.expSeibiEditData = JSON.parse(JSON.stringify(data));
  }

  async updateExpSeibi() {
    if (this.expSeibiEditData.groupCd && this.expSeibiEditData.shatenCd && this.expSeibiEditData.workCd) {
      this.$set(this, "loading", true);
      const status = await this.seibiService.saveMSknExpSeibiDetail(this.expSeibiEditData);
      this.$set(this, "loading", false);
      if (status === 200) {
        this.getExpSeibiList();
        this.$set(this, "expSeibiEditData", []);
      } else {
        this.$message.error("エラー");
      }
    }
  }

  onConfirmExpDelete(item: any) {
    if (item && item.id) {
      this.showConfirmExpDelete = true;
      this.expDelete = item;
    }
  }
  public async deleteExpSeibi() {
    if (this.expDelete && this.expDelete.id) {
      this.$set(this, "loading", true);
      /** 2022-09-15 sh #7846(BQR965) implements the function for exp seibi. [START] */
      // const response = await this.seibiService.deleteExpSeibi(this.expDelete.id);
      const response = await this.seibiService.deleteExpSeibi(this.expDelete.id, this.expDelete);
      /** 2022-09-15 sh #7846(BQR965) implements the function for exp seibi. [END] */
      this.$set(this, "loading", false);
      if (response) {
        this.getExpSeibiList();
      } else {
        this.delay(1000);
      }
      this.expDelete = null;
    }
    this.showConfirmExpDelete = false;
  }

  public async onShowBuhin(item: any) {
    if (item.groupCd && item.shatenCd && item.workCd) {
      // 2022-01-31 morisako kobac-free mod [START]
      item.sknInspectSeibiFeeId = this.form.sknInspectSeibiFeeId;
      // 2022-01-31 morisako kobac-free mod [END]
      const response = await this.seibiService.getExpSeibiBuhin(item);
      this.showWorkBuhinDialog = true;
      if (response) {
        this.$set(this, "expBuhinList", response);
      } else {
        this.$set(this, "expBuhinList", []);
      }
    } else {
      this.$set(this, "expBuhinList", []);
    }
  }

  async saveExpSeibiBuhin() {
    const status = await this.seibiService.saveExpSeibiBuhin(this.expBuhinList);
    this.showWorkBuhinDialog = false;
    if (status === 200) {
    } else {
      this.$message.error("エラー");
    }
  }

  onExpCancel() {
    this.$set(this, "expSeibiEditData", []);
  }

  public async getOsusumeInspectSeibi() {
    this.$set(this, "loading", true);
    // 2022-01-31 morisako kobac-free mod [START]
    this.dialogFreeOfChargeBtnFlg = true;
    // 2022-01-31 morisako kobac-free mod [END]
    const response = await this.seibiService.getOsusumeInspectSeibi(
      this.searchVO, this.form, this.sknInspectSeibiTitle);
    this.$set(this, "loading", false);
    if (response) {
      if (response.length > 0) {
        this.maxCnt = response[0].maxCnt;
      }
      this.$set(this, "osusumeInspectSeibiList", response);
    } else {
      this.maxCnt = 0;
      this.$set(this, "osusumeInspectSeibiList", []);
    }
  }

  async onChangeOsusumeImportKbn(item: any) {
    let data = {
      id: item.id
      , importKbn: item.importKbn
    };
    const status = await this.seibiService.updateOsusumeImportKbn(data);
    if (status === 200) {
    } else {
      this.$message.error("エラー");
    }
  }

  public handleOsusumeSizeChange(event: number) {
    this.searchVO.page = 1;
    this.searchVO.size = event;
    this.getOsusumeInspectSeibi();
  }

  onOpenExtremeImport() {
    this.$refs.dialogExtremeImport.open();
  }

  async onChangeImportKbn(item: any) {
    let data = {
      id: item.sknInspectSeibiDetailId
      , importKbn: item.importKbn
    };
    const status = await this.buhinService.updateImportKbn(data);
    if (status === 200) {
    } else {
      this.$message.error("エラー");
    }
  }

  async onChangeExpImportKbn(item: any) {
    if (item.id) {
      let data = {
        id: item.id
        , importKbn: item.importKbn
      };
      const status = await this.buhinService.updateExpImportKbn(data);
      if (status === 200) {
      } else {
        this.$message.error("エラー");
      }
    } else {
      this.onExpEdit(item);
      this.updateExpSeibi();
    }
  }

  public handleOsusumeCurrentChange(event: number) {
    this.searchVO.page = event;
    this.getOsusumeInspectSeibi();
  }

  // 2022-01-31 morisako kobac-free add [START]
  onChangeIsFree(val: any) {
    this.seibiEditData.isFree = val === 1 ? 1: null;
    if (this.seibiEditData.isFree === 1) {
      this.seibiEditData.isDiscount = null;
    }
  }

  onChangeIsDiscount(val: any) {
    this.seibiEditData.isDiscount = val === 1 ? 1: null;
    if (this.seibiEditData.isDiscount === 1) {
      this.seibiEditData.isFree = null;
    }
  }

  onChangeExpIsFree(val: any) {
    this.expSeibiEditData.isFree = val === 1 ? 1: null;
    if (this.expSeibiEditData.isFree === 1) {
      this.expSeibiEditData.isDiscount = null;
    }
  }

  onChangeExpIsDiscount(val: any) {
    this.expSeibiEditData.isDiscount = val === 1 ? 1: null;
    if (this.expSeibiEditData.isDiscount === 1) {
      this.expSeibiEditData.isFree = null;
    }
  }

  async onChangeOsusumeIsFree(item: any) {
    if (item.isFree === 1) {
      item.isDiscount = null;
    }
    let data = {
      seibiKbn: item.seibiKbn
      , sknInspectSeibiDetailId: item.id
      , sknInspectSeibiFeeId: item.sknInspectSeibiFeeId
      , sknInspectSeibiFeeExtensionId: item.sknInspectSeibiFeeExtensionId
      , isFree: item.isFree
      , isDiscount: item.isDiscount
    };
    const status = await this.seibiService.saveMSknInspectSeibiFeeExtension(data);
    if (status === 200) {
    } else {
      this.$message.error("エラー");
    }
  }

  async onChangeOsusumeIsDiscount(item: any) {
    if (item.isDiscount === 1) {
      item.isFree = null;
    }
    let data = {
      seibiKbn: item.seibiKbn
      , sknInspectSeibiDetailId: item.id
      , sknInspectSeibiFeeId: item.sknInspectSeibiFeeId
      , sknInspectSeibiFeeExtensionId: item.sknInspectSeibiFeeExtensionId
      , isFree: item.isFree
      , isDiscount: item.isDiscount
    };
    const status = await this.seibiService.saveMSknInspectSeibiFeeExtension(data);
    if (status === 200) {
    } else {
      this.$message.error("エラー");
    }
  }

  public async getShatens() {
    if (this.form.groupCd) {
      const response = await this.accountService.getShatens(
        this.form.groupCd
      );
      if (response) {
        this.$set(this, "shatenDataList", response);
      } else {
        this.$set(this, "shatenDataList", []);
      }
      return response;
    }
  }

  selectShaten1() {
    this.getKyotenDataList().then(res3 => {
      if (res3) {
        if (res3.length == 0) {
          this.form.kyotenCd = "";
        } else {
          this.form.kyotenCd = localStorage.getItem("kyotenCd");
        }
        this.getVersionList().then(() => {
          if (this.versionList.length === 1) {
            this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
          }
          this.getFeeList();
        });
      }
    });
  }

  onOpenFreeOfCharge() {
    this.groupCd = this.form.groupCd;
    this.shatenCd = this.form.shatenCd;
    this.shatenNm = this.getShatenNm();
    this.kyotenCd = this.form.kyotenCd;
    this.kyotenNm = this.getKyotenNm();
    this.version = this.form.version;
    this.sknInspectSeibiFeeId = this.form.sknInspectSeibiFeeId;
    this.sknInspectSeibiFeeNm = this.getSknInspectSeibiFeeNm();
    this.$refs.dialogFreeOfCharge.open();
  }

  getShatenNm() {
    let shaten = this.shatenDataList.find((e: any) => e.shatenCd = this.form.shatenCd);
    if (shaten) {
      return shaten.kaishaNm;
    } else {
      return '';
    }
  }

  getKyotenNm() {
    if (this.kyotenDataList && this.kyotenDataList.length > 0) {
      let kyoten = this.kyotenDataList.find((e: any) => e.kyotenCd === this.form.kyotenCd);
      if (kyoten) {
        return kyoten.kyotenNm;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getSknInspectSeibiFeeNm() {
    let fee = this.feeList.find((e: any) => e.sknInspectSeibiFeeId === this.form.sknInspectSeibiFeeId);
    if (fee) {
      return fee.sknInspectSeibiFeeNm;
    }
    return '';
  }

  async saveFreeOfChargeNm() {
    let data = {
      groupCd: this.form.groupCd
      , shatenCd: this.form.shatenCd
      , kyotenCd: this.form.kyotenCd
      , sknHanyouSeibiVersionId: this.form.version
      , sknInspectSeibiFeeId: this.form.sknInspectSeibiFeeId
      , freeOfChargeNm: this.freeOfChargeNm
    };
    const res = await this.shatenService.saveFreeOfCharge(data);
    if (res == 200) {
      this.dialogFreeOfChargeNm = false;
    } else {
      this.$message.error("エラー");
    }
  }

  async openDialogFreeOfChargeNm() {
    this.freeOfChargeNm = '';
    const response = await this.shatenService.getMSknFreeOfCharge(this.form);
    if (response) {
      this.freeOfChargeNm = response.freeOfChargeNm;
    }
    this.dialogFreeOfChargeNm = true;
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-11-25 sh #8128(BQRxxx) get seibi after select changed. [START] */
  onChangeFeeList() {
    this.search();
  }
  /** 2022-11-25 sh #8128(BQRxxx) get seibi after select changed. [END] */
}
